const SECONDARY_VIEWS = {
    NEW_CLIENT: "NEW_CLIENT",
    EDIT_CLIENT: "EDIT_CLIENT",
};

export const CLIENTS_MODULE_UI_CONSTANTS = {
    SECONDARY_VIEWS,
};